import { Channel } from 'phoenix'
import { User } from '../UsersManager'
import { Chat } from './types'
import { chatApi } from './utils'

type Operator = { jid: string; id: number }

type Item = {
  id: number
  skill: string
  operators: Operator[]
}

type Skill = {
  id: number
  name: string
}

export type UserOnRedirectList = {
  saasId: number
  userData: User
  skills: Skill[]
}

const getSkills = (xmpp: string, skills: Item[]): Skill[] =>
  skills
    .filter(skill => skill.skill != 'All operators')
    .filter(skill => skill.operators.find(user => user.jid == xmpp))
    .map(skill => ({
      id: skill.id,
      name: skill.skill,
    }))

export const getUsersRedirectList = async (
  chat: Chat,
  channel: Channel,
  getByXmpp: (xmpp: string) => User | undefined
) => {
  const resp = await chatApi<Item[]>(channel, chat.chatAccountId, {
    module: 'talk',
    method: 'getOperatorRedirectList',
  })

  const skills = resp.length
    ? resp
    : [{ id: -1, skill: 'All operators', operators: [] }]

  return skills
    .find(skill => skill.skill == 'All operators')!
    .operators.map(item => ({
      xmpp: item.jid,
      saasId: item.id,
      skills: [] as Skill[],
    }))
    .map(operator => {
      const user = getByXmpp(operator.xmpp)

      if (!user) {
        return undefined
      }

      return {
        saasId: operator.saasId,
        userData: user,
        skills: getSkills(operator.xmpp, skills),
      } as UserOnRedirectList
    })
    .filter(v => v) as UserOnRedirectList[]
}
